<div class="tenant-capability-page" [testId]="'tenant-capability-config-container'">
  <nz-spin [nzSpinning]="loading" [testId]="'tenant-capability-config-spin'">
    <div class="tenant-capability-page__stack">
      <nz-card class="tenant-capability-page__hero" [testId]="'tenant-capability-config-hero'">
        <h3 class="tenant-capability-page__title" [testId]="'tenant-capability-config-title'">
          {{ 'tenant.detail.capability.section-title' | i18n }}
        </h3>
        <p class="tenant-capability-page__subtitle" [testId]="'tenant-capability-config-subtitle'">
          {{ 'tenant.detail.capability.section-description' | i18n }}
        </p>
      </nz-card>

      <nz-card class="tenant-capability-page__panel" [testId]="'tenant-capability-config-panel'">
        <ng-container *ngIf="hasCapabilities; else emptyState">
          <form nz-form [formGroup]="capabilityForm" class="tenant-capability-list" [testId]="'tenant-capability-config-form'">
            <div class="tenant-capability-item" *ngFor="let param of capabilityParams" [testId]="'tenant-capability-item-' + param.code">
              <div class="tenant-capability-item__body">
                <div class="tenant-capability-item__title-row">
                  <h4 class="tenant-capability-item__title">{{ getCapabilityTitle(param.code) }}</h4>
                  <nz-tag
                    [nzColor]="isCapabilityEnabled(param.code) ? 'green' : 'default'"
                    [testId]="'tenant-capability-status-' + param.code"
                  >
                    {{
                      (isCapabilityEnabled(param.code)
                        ? 'tenant.detail.capability.status-enabled'
                        : 'tenant.detail.capability.status-disabled'
                      ) | i18n
                    }}
                  </nz-tag>
                </div>
                <p class="tenant-capability-item__description">{{ getCapabilityDescription(param.code) }}</p>
              </div>

              <label class="tenant-capability-item__switch">
                <nz-switch [formControlName]="getCapabilityControlName(param.code)" [testId]="'tenant-capability-switch-' + param.code" />
              </label>
            </div>
          </form>

          <div class="tenant-capability-summary" [testId]="'tenant-capability-summary'">
            <span *ngIf="enabledCapabilityCount > 0; else allDisabled">
              {{ 'tenant.detail.capability.summary-enabled' | i18n: { count: enabledCapabilityCount } }}
            </span>
            <ng-template #allDisabled>
              <span>{{ 'tenant.detail.capability.summary-empty' | i18n }}</span>
            </ng-template>
          </div>
        </ng-container>

        <ng-template #emptyState>
          <nz-empty [nzNotFoundContent]="'tenant.detail.capability.empty' | i18n" [testId]="'tenant-capability-config-empty'" />
        </ng-template>

        <div class="tenant-capability-page__footer" [testId]="'tenant-capability-config-actions'">
          <span class="tenant-capability-page__hint">{{ 'tenant.detail.capability.save-hint' | i18n }}</span>
          <div class="tenant-capability-page__buttons">
            <button nz-button nzType="default" (click)="resetCapabilityConfig()" [testId]="'tenant-capability-config-reset-btn'">
              {{ 'common.reset' | i18n }}
            </button>
            <button
              nz-button
              nzType="primary"
              [nzLoading]="saving"
              (click)="saveCapabilityConfig()"
              [testId]="'tenant-capability-config-save-btn'"
            >
              {{ 'tenant.detail.capability.save-action' | i18n }}
            </button>
          </div>
        </div>
      </nz-card>
    </div>
  </nz-spin>
</div>
